"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeEnum = void 0;
var NodeEnum;
(function (NodeEnum) {
    NodeEnum["SOURCE"] = "source";
    NodeEnum["TARGET"] = "target";
})(NodeEnum || (exports.NodeEnum = NodeEnum = {}));
//# sourceMappingURL=citations.js.map